// extracted by mini-css-extract-plugin
module.exports =  {"colorSampleList":"JMI9f0"};